module.exports = __webpack_public_path__ + "img/stripe.70fbd6e7.png";